export default "__VITE_ASSET__ce8cb62d__"